module.exports = __webpack_public_path__ + "img/businessSchool.c4078043.png";